import { createFileRoute } from '@tanstack/react-router';

import { AboutPage } from '~/features/account/about-page';

export const Route = createFileRoute('/_app/account/about/')({
  component: () => <AboutPage kind="privacy" />,
});
